// TODO check it
import React, { Component } from 'react'
import { connect } from 'react-redux'

import {Card, CardActions, CardHeader, CardMedia, CardTitle, CardText} from 'material-ui/Card'
import Divider from 'material-ui/Divider'

import Badge from 'components/Badge'

import sectionsActions from 'actions/sections'

let select = (state, props) => ({
	expanded: state.sections[props.id] !== undefined ? state.sections[props.id] : false
  , accordion: state.accordion
})

export class Section extends Component{
	render(){
		let { props } = this
		return(
			<div className="Section" style={{marginBottom: props.expanded?"10px":"0", marginTop:props.expanded && !props.top?"0px":"0"}}>
				<Card
					expanded={props.accordionID?props.accordionID==props.accordion:(props.needBeExpanded || props.expanded)}
					onExpandChange={(expanded)=> props.SECTION_EXPAND({section: props.id, expanded:props.alwaysExpanded || expanded, accordion: props.accordionID})}
					style={{background:"none", boxShadow: "none", backgroundColor:"white"}}
					initiallyExpanded={true}
				>
					<CardHeader
						titleStyle={{padding:"0", backgroundColor:"white"}}
						title={
							<table style={{width:"calc(100% + 30px)", height: "42px"}}>
								<tr>
									<td
									style={{
										cursor:"default"
									  , padding: "2px 2px 2px 16px"
									  , margin:"0"
									  , whiteSpace: "nowrap"
									}}
									onClick={(expanded)=>props.SECTION_EXPAND({section: props.id, expanded:props.alwaysExpanded || expanded})}>
										<span style={{fontWeight: "bold"}}>{props.title}</span>
										{props.badge>0 &&
											<span
												style={{
													height: "20px"
													, position:"absolute"
													, top:"13px"
												}}
											>
												<Badge
						   							 badgeContent={props.badge}
						   							 secondary={props.badge>0}
													 style={{marginTop: "4px"}}
					   						 	/>
											</span>
										}
									</td>
									<td style={{width:"calc(100% - 400px)"}}></td>
									<td style={{position:"relative", padding: "0", whiteSpace: "nowrap", top:"-2px", width: "216px", left:"7px"}}>
										{props.rightButton}
									</td>
								</tr>
							</table>
						}
						textStyle={{width: "100%"}}
						style={{padding:"10px 0px", backgroundColor:"white"}}
						showExpandableButton={!props.needBeExpanded}
					/>
					<CardText expandable={true} style={{marginTop:"0px", marginBottom:"-30px", padding: "0"}}>
						{props.children}
					</CardText>
				</Card>
			</div>
		)
	}
}

export default connect(select, sectionsActions)(Section)



// WEBPACK FOOTER //
// ./src/components/Communication/SectionMessage.js